/* eslint-disable camelcase */
import { question_gov_001_v2 } from './questions/gov/gov-001-document-officiel-engagement';
import { question_gov_002_v2 } from './questions/gov/gov-002-espece-emblematique';
import { question_gov_003_v2 } from './questions/gov/gov-003-plan-strategique-local';
import { question_gov_004_v2 } from './questions/gov/gov-004-programmes-financement-services';
import { question_gov_005_v2 } from './questions/gov/gov-005-montants-programmes';
import { question_gov_006_v2 } from './questions/gov/gov-006-budget-biodiversite';
import { question_gov_007_v2 } from './questions/gov/gov-007-montant-biodiversite';
import { question_gov_008_v2 } from './questions/gov/gov-008-fonds-protection-biodiversite';
import { question_gov_009_v2 } from './questions/gov/gov-009-montant-fonds';
import { question_gov_010_v2 } from './questions/gov/gov-010-biodiversite-zonage-urbanisme';
import { question_gov_011_v2 } from './questions/gov/gov-011-biodiversite-sad-pmad';
import { question_gov_012_v2 } from './questions/gov/gov-012-biodiversite-pdza';
import { question_gov_013_v2 } from './questions/gov/gov-013-programmes-conservation';
import { question_gov_014_v2 } from './questions/gov/gov-014-montants-habitant-programmes';
import { question_pres_001_v2 } from './questions/pres/pres-001-milieux-connectivite';
import { question_pres_002_v2 } from './questions/pres/pres-002-superficie-aires-protegees';
import { question_pres_003_v2 } from './questions/pres/pres-003-portrait-bandes-riveraines';
import { question_pres_004_v2 } from './questions/pres/pres-004-superficie-spcv';
import { question_pres_005_v2 } from './questions/pres/pres-005-superficie-espaces-conservation';
import { question_pres_006_v2 } from './questions/pres/pres-006-territoire-vocation-conservation';
import { question_pres_007_v2 } from './questions/pres/pres-007-largeur-mailles-effectives';
import { question_pres_008_v2 } from './questions/pres/pres-008-superficie-milieux-terrestres';
import { question_pres_009_v2 } from './questions/pres/pres-009-nombre-parcelles-terrestres';
import { question_pres_010_v2 } from './questions/pres/pres-010-taille-moyenne-parcelles';
import { question_pres_011_v2 } from './questions/pres/pres-011-plus-grande-parcelle';
import { question_pres_012_v2 } from './questions/pres/pres-012-plan-action-connectivite';
import { question_pres_013_v2 } from './questions/pres/pres-013-liens-corridor-connectivite';
import { question_pres_014_v2 } from './questions/pres/pres-014-zones-noyaux-zonage';
import { question_pres_015_v2 } from './questions/pres/pres-015-zones-noyaux-sad-pmad';
import { question_pres_016_v2 } from './questions/pres/pres-016-zones-noyaux-pdza';
import { question_pres_017_v2 } from './questions/pres/pres-017-superficie-ecosystemes-forestiers';
import { question_pres_018_v2 } from './questions/pres/pres-018-part-ecosystemes-forestiers';
import { question_pres_019_v2 } from './questions/pres/pres-019-types-ecosystemes-forestiers';
import { question_pres_020_v2 } from './questions/pres/pres-020-diversite-ecosystemes-forestiers';
import { question_pres_021_v2 } from './questions/pres/pres-021-superficie-milieux-humides';
import { question_pres_022_v2 } from './questions/pres/pres-022-part-milieux-humides';
import { question_pres_023_v2 } from './questions/pres/pres-023-types-milieux-humides';
import { question_pres_024_v2 } from './questions/pres/pres-024-diversite-milieux-humides';
import { question_pres_025_v2 } from './questions/pres/pres-025-complexes-milieux-humides';
import { question_pres_026_v2 } from './questions/pres/pres-026-taille-complexes-humides';
import { question_pres_027_v2 } from './questions/pres/pres-027-superficie-milieux-hydriques';
import { question_pres_028_v2 } from './questions/pres/pres-028-part-milieux-hydriques';
import { question_pres_029_v2 } from './questions/pres/pres-029-liste-especes-statut';
import { question_pres_030_v2 } from './questions/pres/pres-030-liste-complementaire-especes';
import { question_pres_031_v2 } from './questions/pres/pres-031-declaration-especes-statut';
import { question_pres_032_v2 } from './questions/pres/pres-032-programme-suivi-especes-sentinelles';
import { question_pres_033_v2 } from './questions/pres/pres-033-actions-connaissances-especes';
import { question_pres_034_v2 } from './questions/pres/pres-034-plan-retablissement-especes';
import { question_pres_035_v2 } from './questions/pres/pres-035-especes-plan-retablissement';
import { question_pres_036_v2 } from './questions/pres/pres-036-habitats-zonage-urbanisme';
import { question_pres_037_v2 } from './questions/pres/pres-037-habitats-sad-pmad';
import { question_pres_038_v2 } from './questions/pres/pres-038-projets-restauration-milieux';
import { question_pres_039_v2 } from './questions/pres/pres-039-liste-especes-exotiques';
import { question_pres_040_v2 } from './questions/pres/pres-040-declaration-eee';
import { question_pres_041_v2 } from './questions/pres/pres-041-plan-action-eee';
import { question_pres_042_v2 } from './questions/pres/pres-042-budget-eradication-eee';
import { question_pres_043_v2 } from './questions/pres/pres-043-directive-gestion-eee';
import { question_pres_044_v2 } from './questions/pres/pres-044-articles-devis-eee';
import { question_pres_045_v2 } from './questions/pres/pres-045-politique-gestion-eee';
import { question_pres_046_v2 } from './questions/pres/pres-046-programmes-sensibilisation-eee';
import { question_pres_047_v2 } from './questions/pres/pres-047-projets-controle-eee';
import { question_multi_001_v2 } from './questions/multi/multi-001-quartier-vert-ecoquartier';
import { question_multi_002_v2 } from './questions/multi/multi-002-aires-conservation-public';
import { question_multi_003_v2 } from './questions/multi/multi-003-proximite-residences-nature';
import { question_multi_004_v2 } from './questions/multi/multi-004-proximite-etablissements-nature';
import { question_multi_005_v2 } from './questions/multi/multi-005-reglement-eaux-pluviales';
import { question_multi_006_v2 } from './questions/multi/multi-006-coefficient-permeabilite';
import { question_multi_007_v2 } from './questions/multi/multi-007-superficie-vegetation';
import { question_multi_008_v2 } from './questions/multi/multi-008-politique-arbre';
import { question_multi_009_v2 } from './questions/multi/multi-009-non-utilisation-pesticides';
import { question_multi_010_v2 } from './questions/multi/multi-010-campagne-sensibilisation';
import { question_multi_011_v2 } from './questions/multi/multi-011-programme-ruelles-vertes';
import { question_multi_012_v2 } from './questions/multi/multi-012-programmes-sensibilisation-reconnaissance';
import { question_multi_013_v2 } from './questions/multi/multi-013-jardins-partages';
import { question_multi_014_v2 } from './questions/multi/multi-014-potager-terrains-prives';
import { question_multi_015_v2 } from './questions/multi/multi-015-programmes-restauration-friche';
import FormSectionId from '../models/enums/FormSectionId';
import FormSubsectionId from '../models/enums/FormSubsectionId';
import FormSpecKey from '../models/enums/FormSpecKey';
import FormSpecification from '../models/FormSpecification';
import { initFormSpecRegistry } from '../models/FormSpecRegistry';

/* eslint-disable max-len */
const FormSpec: FormSpecification = {
  version: 2,
  acceptedConditions: false,
  municipalityId: '',
  nomMunicipalite: '',
  nomResponsable: '',
  courriel: '',
  telephone: '',
  anneeEtudiee: '',
  anneeAdhesion: '',
  specKey: FormSpecKey.PEXBD_V2,
  programName: '',
  templateSlug: '',
  sections: [
    {
      id: FormSectionId.GOUVERNANCE,
      oldId: '1',
      title: 'Gouvernance',
      subsections: [
        {
          id: FormSubsectionId.GOV_INTEGRATION_FINANCEMENT,
          oldId: '1',
          title: 'Intégration et financement de la préservation de la biodiversité',
          questions: [
            question_gov_001_v2,
            question_gov_002_v2,
            question_gov_003_v2,
            question_gov_004_v2,
            question_gov_005_v2,
            question_gov_006_v2,
            question_gov_007_v2,
            question_gov_008_v2,
            question_gov_009_v2,
            question_gov_010_v2,
            question_gov_011_v2,
            question_gov_012_v2,
            question_gov_013_v2,
            question_gov_014_v2,
          ],
        },
      ],
    },
    {
      id: FormSectionId.PRESERVATION,
      oldId: '2',
      title: 'Préservation',
      subsections: [
        {
          id: FormSubsectionId.PRES_TERRITOIRES_PROTEGES,
          oldId: '1',
          title: 'question 2: Territoires bénéficiant d\'un statut de protection et corridors écologiques',
          questions: [
            question_pres_001_v2,
            question_pres_002_v2,
            question_pres_003_v2,
            question_pres_004_v2,
            question_pres_005_v2,
            question_pres_006_v2,
            question_pres_007_v2,
            question_pres_008_v2,
            question_pres_009_v2,
            question_pres_010_v2,
            question_pres_011_v2,
            question_pres_012_v2,
            question_pres_013_v2,
            question_pres_014_v2,
            question_pres_015_v2,
            question_pres_016_v2,
          ],
        },
        {
          id: FormSubsectionId.PRES_ECOSYSTEMES_ESPECES,
          oldId: '2',
          title: 'question 3: Grands écosystèmes et espèces à statut',
          questions: [
            question_pres_017_v2,
            question_pres_018_v2,
            question_pres_019_v2,
            question_pres_020_v2,
            question_pres_021_v2,
            question_pres_022_v2,
            question_pres_023_v2,
            question_pres_024_v2,
            question_pres_025_v2,
            question_pres_026_v2,
            question_pres_027_v2,
            question_pres_028_v2,
            question_pres_029_v2,
            question_pres_030_v2,
            question_pres_031_v2,
            question_pres_032_v2,
            question_pres_033_v2,
            question_pres_034_v2,
            question_pres_035_v2,
            question_pres_036_v2,
            question_pres_037_v2,
            question_pres_038_v2,
          ],
        },
        {
          id: FormSubsectionId.PRES_ESPECES_EXOTIQUES,
          oldId: '3',
          title: 'question 4: Espèces exotiques envahissantes',
          questions: [
            question_pres_039_v2,
            question_pres_040_v2,
            question_pres_041_v2,
            question_pres_042_v2,
            question_pres_043_v2,
            question_pres_044_v2,
            question_pres_045_v2,
            question_pres_046_v2,
            question_pres_047_v2,
          ],
        },
      ],
    },
    {
      id: FormSectionId.MULTIFONCTIONNALITE,
      oldId: '3',
      title: 'Multifonctionnalité',
      subsections: [
        {
          id: FormSubsectionId.MULTI_SANTE_LOISIRS,
          oldId: '1',
          title: 'question 5: Santé et loisirs',
          questions: [
            question_multi_001_v2,
            question_multi_002_v2,
            question_multi_003_v2,
            question_multi_004_v2,
          ],
        },
        {
          id: FormSubsectionId.MULTI_SERVICES_ECOSYSTEMIQUES,
          oldId: '2',
          title: 'question 6: Services écosystémiques',
          questions: [
            question_multi_005_v2,
            question_multi_006_v2,
            question_multi_007_v2,
            question_multi_008_v2,
          ],
        },
        {
          id: FormSubsectionId.MULTI_ENGAGEMENT_COLLECTIF,
          oldId: '3',
          title: 'question 7: Engagement collectif',
          questions: [
            question_multi_009_v2,
            question_multi_010_v2,
            question_multi_011_v2,
            question_multi_012_v2,
            question_multi_013_v2,
            question_multi_014_v2,
            question_multi_015_v2,
          ],
        },
      ],
    },
  ],
};

// eslint-disable-next-line import/prefer-default-export
export const formSpecRegistryV2 = initFormSpecRegistry(FormSpec);
